import api from '@Services/api';
import { AxiosResponse } from 'axios';
import { AppSetting } from '../Types/AppSetting.types';

export type MarketingSettingsPayload = Pick<
	AppSetting,
	| 'gtm_container_id'
	| 'ga4_measurement_id'
	| 'meta_pixel_id'
	| 'tiktok_pixel_id'
	| 'clarity_project_id'
>;

/**
 * Goes through the same PUT /settings as the Overview form, but sends ONLY the
 * five marketing keys. The backend validator returns just the keys present in
 * the body and the controller runs a partial UPDATE, so nothing else on the
 * settings row can be touched from this tab — and vice versa: the Overview
 * form never sends these keys, so it can't clobber them either.
 */
export const updateMarketingSettings = (
	payload: MarketingSettingsPayload
): Promise<AxiosResponse<ApiResponse<AppSetting>>> => {
	return api.put('settings', payload);
};
